<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col class="d-flex" cols="12" sm="6">
        <v-select dark :items="currencies" label class="my-width" v-model="item" outlined></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="table-responsive overflowhidden"></div>
        <table class="table table-light">
          <thead class="mybackground">
            <th scope="col" class="text-center">DATE</th>
            <th scope="col" class="text-center">LONG</th>
            <th scope="col" class="text-center">SHORT</th>
            <th scope="col" class="text-center">CHANGE LONG</th>
            <th scope="col" class="text-center">CHANGE SHORT</th>
            <th scope="col" class="text-center">% LONG</th>
            <th scope="col" class="text-center">% SHORT</th>
            <th scope="col" class="text-center">NET POSITIONS</th>
          </thead>
          <tbody>
            <tr v-for="x in tableRows" :key="x.date">
              <td class="dateBackground">{{x['date']}}</td>
              <td v-bind:class="x.long_class">{{x['long']}}</td>
              <td v-bind:class="x.short_class">{{x['short']}}</td>
              <td class="dateBackground">{{x['change_long']}}</td>
              <td class="dateBackground">{{x['change_short']}}</td>
              <td class="dateBackground">{{x['percentage_long']}}%</td>
              <td class="dateBackground">{{x['percentage_short']}}%</td>
              <td v-bind:class="x.net_class">{{x.long-x.short}}</td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>
<style >
.overflowhidden {
  overflow-x: hidden;
}
table {
  color: white;
}
thead {
  background-color: #2a9df4 !important;
  text-align: center;
  color: white;
  font-size: 20px;
}
.red4 {
  background-color: #df2612;
  font-weight: bolder;
}
.red3 {
  background-color: #df4533;
}
.red2 {
  background-color: #e35949;
}
.red1 {
  background-color: #e66d5f;
}

.white4 {
  background-color: #65e16d;
  border: 1px solid black;
}
.white3 {
  background-color: #97e18b;
}

.white2 {
  background-color: #cde5d0;
}
.white1 {
  background-color: #edeff0;
}

.green4 {
  background-color: #49e20e;
}
.green3 {
  background-color: #55ae3a;
}

.green2 {
  background-color: #c5e3bf;
}
.green1 {
  background-color: #33df59;
}
.mybackground {
  background-color: #3d98e1;
  color: white;
}
tr {
  text-align: center;
}
td {
  border: solid #000 !important;
  border-width: 1 1px !important;
  text-align: center;
}
.dateBackground {
  background-color: #272727;
  color: white;
}
</style>
<script>
import { db } from "../firebase";

export default {
  data: () => ({
    accounts: [],

    item: "RUSSIAN RUBLE - CHICAGO MERCANTILE EXCHANGE",
    items: [
      "RUSSIAN RUBLE - CHICAGO MERCANTILE EXCHANGE",
      "CANADIAN DOLLAR - CHICAGO MERCANTILE EXCHANGE",
      "SWISS FRANC - CHICAGO MERCANTILE EXCHANGE",
      "MEXICAN PESO - CHICAGO MERCANTILE EXCHANGE",
      "BRITISH POUND STERLING - CHICAGO MERCANTILE EXCHANGE",
      "JAPANESE YEN - CHICAGO MERCANTILE EXCHANGE",
      "BRAZILIAN REAL - CHICAGO MERCANTILE EXCHANGE",
      "NEW ZEALAND DOLLAR - CHICAGO MERCANTILE EXCHANGE",
      "SOUTH AFRICAN RAND - CHICAGO MERCANTILE EXCHANGE",
      "BITCOIN - CHICAGO MERCANTILE EXCHANGE",
      "AUSTRALIAN DOLLAR - CHICAGO MERCANTILE EXCHANGE",
      "U.S. DOLLAR INDEX - ICE FUTURES U.S."
    ],
    headers: [
      { text: "DATE", value: "Date", class: "mybackground" },
      { text: "LONG", value: "Long" },
      { text: "SHORT", value: "Short" },
      { text: "CHANGE LONG", value: "Change Long" },
      { text: "CHANGE SHORT", value: "Change Short" },
      { text: "% LONG", value: "% LONG" },
      { text: "% SHORT", value: "% SHORT" },
      { text: "NET POSITIONS", value: "NET POSITIONS" }
    ],
    tableItems: [
      {
        Date: "5/19/2020",
        Long: 24515,
        Short: 7218,
        "Change Long": 559,
        "Change Short": -228,
        "% LONG": "77.9%",
        "% SHORT": "22.9%",
        "NET POSITIONS": 17297
      }
    ]
  }),
  methods: {
    round: function(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    }
  },
  computed: {
    currencies() {
      let currencies = [];
      if (this.accounts != [])
        for (var i = 0; i < this.accounts.length; i++)
          currencies.push(this.accounts[i][".key"]);

      return currencies;
    },

    tableRows() {
      let accounts = this.accounts;
      let tableData = [];
      for (var i = 0; i < this.accounts.length; i++)
        if (accounts[i][".key"] === this.item) {
          var  max ="";
          var min ="";

          for(var y in accounts[i])
          {
            if(min =="")
            min = accounts[i][y]["long"] - accounts[i][y]["short"] ;

            if(max ==="")
            max =               accounts[i][y]["long"] - accounts[i][y]["short"];
            else 
            if(max<accounts[i][y]["long"] - accounts[i][y]["short"])
            max = accounts[i][y]["long"] - accounts[i][y]["short"];
if(min> accounts[i][y]["long"] - accounts[i][y]["short"])
            min = accounts[i][y]["long"] - accounts[i][y]["short"];            
          }
          var difference = max-min;
          var range = difference/9;
          var ranges = [];
          for(var p =0;p<9;p++)
          ranges.push(min + range*p);
          console.log(ranges);
          

          for (var date in accounts[i]) {
            accounts[i][date]["percentage_long"] =
              accounts[i][date]["long"] /
              (accounts[i][date]["long"] + accounts[i][date]["short"]);
            accounts[i][date]["percentage_long"] *= 100;
            accounts[i][date]["percentage_long"] = this.round(
              accounts[i][date]["percentage_long"],
              1
            );
            accounts[i][date]["percentage_short"] =
              accounts[i][date]["short"] /
              (accounts[i][date]["long"] + accounts[i][date]["short"]);
            accounts[i][date]["percentage_short"] *= 100;
            accounts[i][date]["percentage_short"] = this.round(
              accounts[i][date]["percentage_short"],
              1
            );
            accounts[i][date]["short_class"] = "white";
            accounts[i][date]["net_positions"] =
              accounts[i][date]["long"] - accounts[i][date]["short"];

            var x = accounts[i][date]["net_positions"] ;
            

          
            
            if (x <=ranges[0]) accounts[i][date]["net_class"] = "red4";
            else if (x <=ranges[1]) accounts[i][date]["net_class"] = "red3";
            else if (x <=ranges[2]) accounts[i][date]["net_class"] = "red2";
            else if (x <=ranges[3]) accounts[i][date]["net_class"] = "red1";
            else if (x <= ranges[4]) accounts[i][date]["net_class"] = "white1";
            else if (x <= ranges[5]) accounts[i][date]["net_class"] = "white2";
            else if (x <= ranges[6]) accounts[i][date]["net_class"] = "white3";
            else if (x <= ranges[7]) accounts[i][date]["net_class"] = "white4";
            else  accounts[i][date]["net_class"] =  "green1";
          
            x = accounts[i][date]["percentage_long"];
            if (x <= 10) accounts[i][date]["long_class"] = "red4";
            else if (x <= 23) accounts[i][date]["long_class"] = "red3";
            else if (x <= 37) accounts[i][date]["long_class"] = "red2";
            else if (x <= 45) accounts[i][date]["long_class"] = "red1";
            else if (x <= 55) accounts[i][date]["long_class"] = "white1";
            else if (x <= 64) accounts[i][date]["long_class"] = "white2";
            else if (x <= 74) accounts[i][date]["long_class"] = "white3";
            else if (x <= 84) accounts[i][date]["long_class"] = "white4";
            else accounts[i][date]["long_class"] = "green1";

            x = accounts[i][date]["percentage_short"];
            x = accounts[i][date]["percentage_short"];
            if (x <= 10) accounts[i][date]["short_class"] = "red4";
            else if ((x <=     23)) accounts[i][date]["short_class"] = "red3";
            else if (x <= 37) accounts[i][date]["short_class"] = "red2";
            else if (x <= 45) accounts[i][date]["short_class"] = "red1";
            else if (x <= 55) accounts[i][date]["short_class"] = "white1";
            else if (x <= 64) accounts[i][date]["short_class"] = "white2";
            else if (x <= 74) accounts[i][date]["short_class"] = "white3";
            else if (x <= 84) accounts[i][date]["short_class"] = "white4";
            else accounts[i][date]["short_class"] = "green1";

            accounts[i][date]["date"] = accounts[i][date]["date"].replace(
              "-",
              "/"
            );
            accounts[i][date]["date"] = accounts[i][date]["date"].replace(
              "-",
              "/"
            );
    //         accounts.sort(function(a,b){
    //           console.log(a);
    //            var aa = a.split('/').reverse().join(),
    //     bb = b.split('/').reverse().join();
    // return aa < bb ? -1 : (aa > bb ? 1 : 0);
    //         })

tableData.push(accounts[i][date]);

          }
        }
        
      for(var pa =0;pa<tableData.length;pa++)
      {
          var datearray  = tableData[pa]['date'].split("/")

                  tableData[pa  ]['date'] = datearray[1] + '/' + datearray[0] + '/' + datearray[2]; 

      }
    tableData.sort(function(ax,bx){

      var a = ax['date'];
      var b= bx['date'];
          var aa = a.split('/').reverse().join(),
        bb = b.split('/').reverse().join();
    return aa < bb ? -1 : (aa > bb ? 1 : 0);
    })
    
      tableData.reverse();
      
       return tableData;
    }
    
  },
  firebase: {
    accounts: db.ref("currencies")
  }
};
</script>